export default __webpack_public_path__ + "static/egyszeru_latogatas-e574b213fde66d835e76d92bacdbf82f.pdf";